import React from 'react';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { getJobNoticeData } from './utils/noticeUtils';

const LongBuildNotice = ({ job, pumpDetails, noticeData = null }) => {
  // Use provided notice data or generate it
  const notices = noticeData || getJobNoticeData(job, pumpDetails);
  
  // Check if long build notice should be displayed
  if (!notices.notices.longBuild?.hasNotice) {
    return null;
  }

  const { tplValue } = notices.notices.longBuild;

  return (
    <Alert variant="warning" className="mb-3">
      <Alert.Heading className="h6 mb-2">
        <i className="bi bi-arrows-vertical me-2"></i>
        Long Build Pumps Detected - <strong>TPL Value:</strong> {tplValue}"
      </Alert.Heading>
    </Alert>
  );
};

LongBuildNotice.propTypes = {
  job: PropTypes.object.isRequired,
  pumpDetails: PropTypes.array,
  noticeData: PropTypes.object,
};

export default LongBuildNotice;